import { FileExportService } from './../../services/file-export.service';
import { ItemList } from './../../model/item-list';
import { BolGenXML } from './../../model/bol-gen-xml';
import { PoTypeDto } from './../../model/po-type-dto';
import { Component, OnInit } from '@angular/core';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { PartnerDto } from 'src/app/model/partner-dto';
import { BolItemLinesResponseDto } from 'src/app/model/bol-item-lines-response-dto';
import { BolItemLinesRequestDto } from 'src/app/model/bol-item-lines-request-dto';
import { BillOfLadingHeader } from 'src/app/model/bill-of-lading-header';
import { formatDate, DatePipe } from '@angular/common';
import { BolResponse } from 'src/app/model/bol-response';
import { XmlFileService } from 'src/app/services/xml-file.service';
import { BillOfLading } from 'src/app/model/bill-of-lading';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderDetailsdto } from '../../model/orderDetailsdto';
import { OrderInterfaceLogDto } from '../../model/orderInterfaceLogDto';


import xml2js from 'xml2js';

declare var $: any;
@Component({
  selector: 'app-create-test-bol',
  templateUrl: './create-test-bol.component.html',
  styleUrls: ['./create-test-bol.component.css']
})
export class CreateTestBolComponent implements OnInit {
  constructor(private route: ActivatedRoute,private router: Router,private httpclientService: HttpclientService, public appSettingService: AppSettingService, private datePipe: DatePipe,
              public xmlFileService: XmlFileService) {
// this.customerOrderDate =  formatDate(this.today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530');
this.customerOrderDate =  this.datePipe.transform(this.today, this.appSettingService.globelDateTimeFormat);
this.isDistributor = sessionStorage.getItem('roleId')!='6' ? false : true;
this.isAdmin = sessionStorage.getItem('roleId')=='1' ? true : false;
}
oneAtATime;
showArrow: any[] = [];
  orderDetailsdto: OrderDetailsdto;
  orderInterfaceLogList:OrderInterfaceLogDto[];
  initialOrderDetailsdto: OrderDetailsdto;
  isDistributor:boolean;
  isAdmin:boolean;
  public loading: boolean;
  isFromViewBol: boolean = false;
  partnerDtoList: PartnerDto[];
  potypeDtoList: PoTypeDto[];
  bolItemLinesResponseDtoList: BolItemLinesResponseDto[];
  bolItemLinesResponseDtoListCopy: number[] = [];
  bolItemLinesResponseDtoChkBoxListCopy: boolean[] = [];
  bolItemLinesRequestDto: BolItemLinesRequestDto;
  partnerModal;
  partnerName: string;
  poNumber: string;
  axaltaCartKey: string;
  distributorBolDate: string;
  freight:string;
  disBlk = false;
  showMessage;
  poTypeModal;
  bolResponse: BolResponse;

  bolGenXML: BolGenXML;
  billOfLading: BillOfLading;
  billOfLadingHeader: BillOfLadingHeader;
  itemList: ItemList[] = [];
  supplierDocReferenceNumberModal;
  copySupplierDocReferenceNumberModal;
  customerOrderDate;
  today = new Date();
  poTypeError;
  distributerError;
  supplierDocError: any = '';
  supplierDocErrorContain: any = '';
  bolSuccessMessage;
  bolXmlCreationMessage: boolean;
  bolXmlCreationTxtMessage: boolean;
  isViewXmlButton;
  isNoError;
  isNoErrorPopup;
  createModalPopup;
  resetModalPopup;
  closeOpenLineModalPopup;
  resetBtnEnableDisable = true;
  isCreateButton = true;  
  isCreateButtonVisible = false;
  isRestButtonClicked = false;
  isPageLoadFirstTime = true;
  arryop: any;
searchIconActive = false;
isCloseLineOpenItems = false;
responseResult = '';
responseResultDesc = '';
bolFileName;
isBolLineItemError;
uploadSupplierModal;
qtyError;

private sub: any;
poType: string;
purchaseOrderNumber: string;
purchaseOrderID: string;
axaltaKey: string;
disributor: string;
poTypeId: String;
bolQuant: any;


public uploadSupplierList = [{label: 'No', value: 'NO'},{label: 'Yes', value: 'YES'}];
  ngOnInit() {
    this.partnerModal = '-1';
    this.poTypeModal = '-1';
    this.uploadSupplierModal = this.uploadSupplierList[0].value;
    this.getPartnerDataList();
    this.getPotypeDataList();    
    this.isViewXmlButton = true;
    
    this.sub = this.route.params.subscribe(params => {
     
        this.poTypeModal = 'Standard PO';
        this.poNumber = '' + params['ponumber'];
        this.partnerModal = '' + params['distributor'];
        this.purchaseOrderID = '' + params['purchaseOrderID']; 
        this.purchaseOrderID = '' + params['purchaseOrderID']; 
        this.axaltaKey      =  '' + params['axaltaCartKey']; 
        this.setPartnerNameForDistributorView();                 
    });
    
    

    $(document).ready(
         () => {          
          //Order History Call          
          this.getBolData();          
         }
         
       )
       

    // $(document).ready(
    //   () => {
    //     let searchInp = $(".searchContr .searchInput");
    //     let searchCloseIcon = $(".searchCloseIcon")
    //     $(searchInp).on("focus", function () {
    //       $(".searchIcon").addClass("searchIconActive")
    //       $(".searchCloseIcon").fadeIn("slow")
    //     })
    //     $(searchInp).on("blur", function () {
    //       $(".searchIcon").removeClass("searchIconActive")
    //       $(".searchCloseIcon").fadeOut("slow")
    //     })
    //   }
    // )    
    
    this.isCreateButton = true;

  }

  tableinner()
  {
    $('.show').addClass('innerTable');
  }

  selecteSupplier(){

  }


  isNullValueEvent() {
    this.isNoErrorPopup = false;
    this.qtyError = false;

  }

  openPopupCreateBOL() {
    this.createModalPopup = true;
  }

  openPopupResetAllFields() {
    this.resetModalPopup =  true;
  }

  closeOpenLines() {
    this.closeOpenLineModalPopup =  true;
  }

  closeOpenLinesAllFields()
  {
    this.isCloseLineOpenItems = true;
    //nnavigate to Order details page
    //[routerLink]="['/order-details', purchaseOrderID, poNumber, 'Cancelled','PO']"
    //http://localhost:4200/#/order-details/34816/BMWRKK2911/Partial/PO
    //Mark all line items 0 and then process and afterthat navigate to order details page
    
    for(let i=0; i<this.bolItemLinesResponseDtoList.length; i++)
    {

      let bolLineItem = this.bolItemLinesResponseDtoList[i];
      
      if((bolLineItem.orderQuantity - bolLineItem.shippedQuantity) != 0)  
      {   
        
        this.bolItemLinesResponseDtoList[i].cancleLineItemCheckBox = true;  
      }
      else
      {    
        
        this.bolItemLinesResponseDtoList[i].cancleLineItemCheckBox = false;  
      }
    }

    const min = this.datePipe.transform(this.customerOrderDate, 'mm');
    const sec = this.datePipe.transform(new Date(), 'ss'); 

    if(this.supplierDocReferenceNumberModal == '')
    {
      
      this.supplierDocReferenceNumberModal = 'DASH-'+min+sec;
    
    }
    else
    {
      this.supplierDocReferenceNumberModal = 'DASH-'+min+sec;
    }

    this.createBOL();   
    this.closeOpenLineModalPopup =  false;
  }

  closeOpenLinesCancel()
  {
    this.closeOpenLineModalPopup =  false;
    this.isCloseLineOpenItems = false;
  }

  pressingCancel() {
    this.createModalPopup = false;
    this.resetModalPopup =  false;
  }
  getBolData() {
    const xmlop = '<?xml version="1.0" encoding="UTF-8"?>'
    + ' <Axalta version="1.0" lang="en-US" docType="BoLResponse" flow="10">'
    + ' <Response timestamp="2020-02-19T12:58:47" customerOrderID="KB001" customerOrderDate="2019-08-10T12:00:00">'
    + '  <AxaltaCartKey>M2002191240439324258</AxaltaCartKey>'
    + ' <SupplierDocReferenceNumber>TEST BOLKB</SupplierDocReferenceNumber>'
    + ' <Status text="OK" code="200">Status Code: 200. OK</Status>'
    + '</Response>'
    + '</Axalta>';


    // this.parseXML(xmlop)
    //       .then((data) => {
    //         this.arryop = data;
    //       });
    // console.log('paring..' + this.parseXML(xmlop));

    this.loading = true;
    this.bolSuccessMessage = '';
    //this.isViewXmlButton = true;
    //this.bolPoNumberSearchValidation();
    
    this.isCreateButton = true;
    this.showMessage = '';
   
    this.selectePartner();
   
    if (this.partnerModal !== '-1' && this.poTypeModal !== '-1'  ) {
    this.bolItemLinesRequestDto = {
      partnerId: this.partnerModal,     
      poType: this.poTypeModal,      
      //poNumber: 'Test004DONOTPROCESS',
      poNumber: this.poNumber,
      poNo:this.purchaseOrderID,

      //poNumber: this.purchaseOrderNumber,
    };
    
    this.httpclientService.getBolLineItem(this.bolItemLinesRequestDto).subscribe(
      
       data => {
        
          this.bolItemLinesResponseDtoList = data;   
          let bolSize = this.bolItemLinesResponseDtoList.length;          
          this.orderDetailsdto = this.bolItemLinesResponseDtoList[bolSize-1].orderDetailHistoryDetailList;
          this.orderInterfaceLogList = this.bolItemLinesResponseDtoList[bolSize-1].orderDetailHistoryDetailList.orderInterfaceLogDtoList;          
          if (data.length > 0) {
          this.showMessage = '';
          this.axaltaCartKey = this.bolItemLinesResponseDtoList[0].axaltaCartKey;
          this.distributorBolDate = this.datePipe.
          transform(this.bolItemLinesResponseDtoList[0].supplierShipDate, this.appSettingService.globelDateTimeFormat);
          this.bolItemLinesResponseDtoList.forEach(pdto => {
            if (pdto.orderQuantity <= pdto.shippedQuantity) {
                pdto.shippedQuantityValidation = true;
            } else {
              pdto.shippedQuantityValidation = false;
            }
           

            if(!this.isRestButtonClicked)
            {
              if((pdto.orderQuantity - pdto.shippedQuantity) != 0)
              {              
                
                //this.isCreateButton =false;
                this.clearField();
              }
            }
                      
            });
          this.isRestButtonClicked = false;
          if(this.isPageLoadFirstTime)
          {
              this.isCreateButton =true;   
              
          }
          
          this.isPageLoadFirstTime = false;//true at time of load after theat alwase false  

        } else {
          this.axaltaCartKey = '';
          this.distributorBolDate = '';
          this.freight = '';
          this.bolItemLinesResponseDtoList = [];
          this.showMessage = 'PO Number is Not Found';
        }
          this.loading = false;
          this.tableinner();
        }
      );      
    } else {
      this.loading = false;

    }
    this.isFromViewBol = false; 
          
  }

  getPartnerDataList() {
    this.loading = true;
    if (this.appSettingService.partnerMSOGlobelList === null || this.appSettingService.partnerMSOGlobelList === undefined ) {
      this.httpclientService.getPartnerList().subscribe(
        data => {
          this.appSettingService.partnerMSOGlobelList = data;
          this.partnerDtoList = data;
          //this.loading = false;
        }
      );
      } else {
        this.partnerDtoList = this.appSettingService.partnerMSOGlobelList;
        //this.loading = false;
      }
  }

  getPotypeDataList() {
    this.loading = true;
    if (this.appSettingService.poTypeDtoMasterList === null || this.appSettingService.poTypeDtoMasterList === undefined ) {
      this.httpclientService.getPoTypeMasterList().subscribe(
        data => {
          this.appSettingService.poTypeDtoMasterList = data;
          this.potypeDtoList = data;
          //this.loading = false;
        }
      );
      } else {
        this.potypeDtoList = this.appSettingService.poTypeDtoMasterList;
        //this.loading = false;
      }
  }

  selectePOType() {
    
    this.poType = ''+this.poTypeModal;
  }

  
  setPartnerNameForDistributorView() {     
    //console.log('setPartnerNameForDistributorView call method : ' + this.partnerDtoList); 
    //console.log('setPartnerNameForDistributorView call method : ' + this.partnerModal);       
    this.partnerName = '';
    this.partnerDtoList.forEach(partner => {
      if (partner.partnerId === Number(this.partnerModal)) {
        this.partnerName = partner.partnerName;        
      }
    });
    
 }

  selectePartner() {
    if (this.partnerDtoList && this.partnerModal) {
        
    this.partnerName = '';
    this.partnerDtoList.forEach(partner => {
      if (partner.partnerId === Number(this.partnerModal)) {
        this.partnerName = partner.partnerName;
      }
    });
  }

}
cancelserach(count, search) {
//   console.log("5-->>");
//   this.showMessage="";
//   if(count == 2 && search.length >=3){

//    this.purchaseorders =this.intialPurchaseOrderListOne;
//  }
}
chkVal() {
 this.disBlk = true;
 this.searchIconActive = true;
}
blurOut() {
  this.searchIconActive = false;  
  
  this.isCreateButton =false;
}
valDel() {
  this.poNumber = '';
  this.disBlk = false;
  this.searchIconActive = false;
  //this.isCreateButton =true;
}

onchangeEdit(event: any,dataField: any, index: number , dataValue: any) {
  
  this.bolQuant = Number(this.bolItemLinesResponseDtoList[index].orderQuantity) - Number(this.bolItemLinesResponseDtoList[index].shippedQuantity);
  console.log('this.bolQuant = ' + this.bolQuant);
  console.log('dataValue.target.value = ' + dataValue.target.value);
  

  if(this.bolQuant >= dataValue.target.value)
  {    
    if(dataValue.target.value == '')
    {    
      this.bolItemLinesResponseDtoList[index].bolQuantity = this.bolQuant;      
      event.target.value = this.bolQuant;
    }
    else
    {   
      this.bolItemLinesResponseDtoList[index].bolQuantity = Number(dataValue.target.value);      
      event.target.value = dataValue.target.value;
    }
  }
  else
  {    
    event.target.value = this.bolQuant;
    this.bolItemLinesResponseDtoList[index].bolQuantity = this.bolQuant;    
  }
  
  //console.log('this.bolItemLinesResponseDtoList[index].bolQuantity After update value : ' + this.bolItemLinesResponseDtoList[index].bolQuantity);
  //console.log('index..'+index+'..'+ dataValue.target.value);
  //console.log('event.target.value = '+event.target.value);

  //console.log('dataField : ' + dataField);

  
  // console.log('resulr..'+(this.bolItemLinesResponseDtoList[index].orderQuantity >
  //  (Number(this.bolItemLinesResponseDtoList[index].bolQuantity)
  // + Number(this.bolItemLinesResponseDtoList[index].shippedQuantity) )));

  // if(this.bolItemLinesResponseDtoList[index].orderQuantity > (Number(this.bolItemLinesResponseDtoList[index].bolQuantity)
  // + Number(this.bolItemLinesResponseDtoList[index].shippedQuantity))){
  // this.bolItemLinesResponseDtoList[index].bolQuantity = dataValue.target.value;
  // this.bolItemLinesResponseDtoList[index].bolQuantityValidation = 1;
  // } else {
  //   this.bolItemLinesResponseDtoList[index].bolQuantityValidation = 0;
  //   this.isNoError = true;
  //   // this.bolItemLinesResponseDtoList[index].bolQuantity = 0;
  // }
 // this.orderDetailsdto.orderItemDtoList[index].editableFlag = 1;

}

bolValidation() {
  if (this.partnerModal === '-1') {
    this.loading = false;
    this.distributerError = 'Please choose Distributor';
    } else {
      this.distributerError = '';
    }

  if (this.poTypeModal === '-1') {
    this.loading = false;
    this.poTypeError = 'Please choose PO Type';
      } else {
        this.poTypeError = '';
      }

  if (!this.poNumber) {
    this.loading = false;
    this.showMessage = 'Please Enter PO Number';
      }  else {
        this.showMessage = '';
      }

  if (this.supplierDocReferenceNumberModal === undefined || this.supplierDocReferenceNumberModal === '') 
  {    
      this.supplierDocError = 'Please enter the Supplier Doc Ref No.';
  } 
  else
  {
    this.supplierDocError = '';
  }
}

bolPoNumberSearchValidation() {
  
  if (this.partnerModal === '-1') {
    if(sessionStorage.getItem('roleId') === '1')
    {
      this.distributerError = '';
    }
    else
    {
      this.distributerError = 'Please choose Distributor.';
      this.loading = false;
    }
    } else {
      this.distributerError = '';
    }

  if (this.poTypeModal === '-1') {
      if(sessionStorage.getItem('roleId') === '1')
      {
        this.poTypeError = '';
      }
      else
      {
        this.poTypeError = 'Please choose PO Type';
        this.loading = false;        
      }
      } else {
        this.poTypeError = '';
      }
  if (!this.poNumber) {
        this.showMessage = 'Please Enter PO Number';
        this.loading = false;
              } else {
                this.showMessage = '';
              }
}



addNum(index: number){  
  if(this.bolItemLinesResponseDtoList[index].orderQuantity > (Number(this.bolItemLinesResponseDtoList[index].bolQuantity)
   + Number(this.bolItemLinesResponseDtoList[index].shippedQuantity))){
   const oldValue = this.bolItemLinesResponseDtoList[index].bolQuantity;
   this.bolItemLinesResponseDtoList[index].bolQuantity = oldValue + 1;
   this.validateLineItemBolCreationCnt();
  }  
  }

subNum(index: number) {
if (this.bolItemLinesResponseDtoList[index].bolQuantity > 0){
  const oldValue = this.bolItemLinesResponseDtoList[index].bolQuantity;
  this.bolItemLinesResponseDtoList[index].bolQuantity = oldValue - 1;  
  this.validateLineItemBolCreationCnt();
}

 }

 validateLineItemBolCreationCnt()
 {   
   let sumOfAllLineItem = 0;
   this.bolItemLinesResponseDtoList.forEach(pdto => {  
    sumOfAllLineItem += pdto.bolQuantity;         
  });
  
  if(this.supplierDocReferenceNumberModal !== '')
  {
  if(sumOfAllLineItem == 0)
  {    
    this.isCreateButton =true;
  }
  else
  {    
    this.isCreateButton =false;
  }
 }
}

  async createBOL() {
  this.createModalPopup = false;
  this.loading = true;
  this.bolValidation();
  
  if (this.partnerModal !== '-1' && this.poTypeModal !== '-1' &&
  this.supplierDocReferenceNumberModal !== undefined && this.supplierDocReferenceNumberModal !== '') {
  this.isNoError = false;
  this.isBolLineItemError = true;
  this.copySupplierDocReferenceNumberModal = this.supplierDocReferenceNumberModal;
  this.bolItemLinesResponseDtoList.forEach(pdto => {
    console.log('pdto.bolQuantity..' + pdto.bolQuantity);

    if (pdto.orderQuantity < (Number(pdto.bolQuantity) + Number(pdto.shippedQuantity)) ) {
        pdto.bolQuantityValidation = 0;
        this.isNoError = true;
    } else {
      pdto.bolQuantityValidation = 1;
    }

    if (pdto.bolQuantity > 0) {
      this.isBolLineItemError = false;
    }


    });
  console.log('pdto.isNoError..' + this.isNoError + '.. this.isBolLineItemError.'+ this.isBolLineItemError);
  if (!this.isNoError && !this.isBolLineItemError) {


  this.billOfLadingHeader = {
    customerOrderDate: '' +  this.datePipe.transform(this.customerOrderDate, 'y-MM-ddTHH:mm:ss'),
    customerOrderID: '' + this.poNumber,
    axaltaCartKey: '' + this.axaltaCartKey,
    supplierShipDate: '' +  this.datePipe.transform(this.distributorBolDate, 'y-MM-ddTHH:mm:ss') ,
    supplierDocReferenceNumber: '' + this.supplierDocReferenceNumberModal,
    
  };
  this.itemList = [];
  this.bolItemLinesResponseDtoListCopy = [];
  this.bolItemLinesResponseDtoChkBoxListCopy = [];
  
  this.bolItemLinesResponseDtoList.forEach(pdto => {
    console.log('pdto.bolQuantity..' + pdto.bolQuantity);    
    let item: ItemList;
    item = {
      customerLineNumber: '' + pdto.line,
      supplierPartID: '' + pdto.supplierPartID,
      axaltaPartID: '' + pdto.axaltaPartID,
      supplierShippedQuantity: '' + pdto.bolQuantity,
      supplierUnitOfMeasure: '' + pdto.supplierUom,
      customerPartID: '' ,
      chkBolLineItem: pdto.cancleLineItemCheckBox,
    };
    this.bolItemLinesResponseDtoListCopy.push(pdto.bolQuantity);    
    this.bolItemLinesResponseDtoChkBoxListCopy.push(pdto.cancleLineItemCheckBox);
    this.itemList.push(item);
  });

  this.bolGenXML = {
    partnerId: this.partnerModal,
    poType: this.poTypeModal,
    billOfLading: {
      billOfLadingHeader: this.billOfLadingHeader,
      itemList: this.itemList
    }

  };
  console.log('request json....' + this.bolGenXML);
  this.bolSuccessMessage = '';
//
  if (this.uploadSupplierModal === 'YES') {

    this.httpclientService.copyBolXML(this.bolGenXML).subscribe(
      data => {
        this.bolSuccessMessage = 'Success Send BOL by Supplier';
        this.loading = false;
      }
    );

  } else {
  if (this.poTypeModal === 'Standard PO' ) {

    this.httpclientService.createBOL(this.bolGenXML).subscribe(
      data => {

        this.bolResponse = data;

        console.log('response json....' + this.bolResponse.bolResponse);
        this.processBolMessage();
       // this.bolItemLinesResponseDtoList = [];
        this.loading = false;
        //this.isViewXmlButton = false;
        if(this.isCloseLineOpenItems)
        {
          this.router.navigate(['/order-details/' + this.purchaseOrderID + '/' + this.poNumber + '/' + 'Cancelled' + '/' + 'PO' + '/' + this.axaltaCartKey]);
        }
      }     
    );
    // await this.getBolData();
  } else {

  this.httpclientService.createBOLForReturnPo(this.bolGenXML).subscribe(
      data => {
        this.bolResponse = data;

       // alert("response.."+ this.bolResponse.bolResponse);
        console.log('response json....' + this.bolResponse.bolResponse);
        this.processBolMessage();        
        // this.bolItemLinesResponseDtoList = [];
        this.loading = false;
        //this.isViewXmlButton = false;
      }
    );

  }
}
  } else {
    this.loading = false;

    if (this.isBolLineItemError) {

  //     if (this.uploadSupplierModal === 'YES') {



  // this.billOfLadingHeader = {
  //   customerOrderDate: '' +  this.datePipe.transform(this.customerOrderDate, 'y-MM-ddTHH:mm:ss'),
  //   customerOrderID: '' + this.poNumber,
  //   axaltaCartKey: '' + this.axaltaCartKey,
  //   supplierShipDate: '' +  this.datePipe.transform(this.distributorBolDate, 'y-MM-ddTHH:mm:ss') ,
  //   supplierDocReferenceNumber: '' + this.supplierDocReferenceNumberModal,
  // };
  // this.itemList = [];
  // this.bolItemLinesResponseDtoList.forEach(pdto => {
  //   console.log('pdto.bolQuantity..' + pdto.bolQuantity);
  //   let item: ItemList;
  //   item = {
  //     customerLineNumber: '' + pdto.line,
  //     supplierPartID: '' + pdto.supplierPartID,
  //     axaltaPartID: '' + pdto.axaltaPartID,
  //     supplierShippedQuantity: '' + pdto.bolQuantity,
  //     supplierUnitOfMeasure: '' + pdto.supplierUom,
  //     customerPartID: '' ,
  //   };
  //   this.itemList.push(item);
  // });

  // this.bolGenXML = {
  //   partnerId: this.partnerModal,
  //   poType: this.poTypeModal,
  //   billOfLading: {
  //     billOfLadingHeader: this.billOfLadingHeader,
  //     itemList: this.itemList
  //   }

  // };
  // this.loading = true;
  // this.bolSuccessMessage = '';
  // this.httpclientService.copyBolXML(this.bolGenXML).subscribe(
  //         data => {
  //           this.bolSuccessMessage = 'Success Send BOL by Supplier';
  //           this.loading = false;
  //         }
  //       );
  //     } else {
    this.qtyError = true;
// this.bolSuccessMessage = 'The BoL quantity should be greater than 0';
     // }
    } else {
      this.isNoErrorPopup = true;
    }
  }

 } else {
  this.loading = false;
  this.bolValidation();
}
}

processBolMessage()
{  
  this.bolXmlCreationTxtMessage = false;
  if (this.bolResponse.statusCode === '200') {
    this.bolXmlCreationMessage = true;
    this.bolSuccessMessage = 'The BOL was successfully created';
    window.setTimeout(() => {this.bolXmlCreationMessage = false
      this.getBolData();}, 1500); 
      this.isViewXmlButton = false; 
      this.isFromViewBol = true;  
      this.clearField(); 
      
  } else{    
    this.bolXmlCreationMessage = false;    
     this.bolSuccessMessage = this.bolResponse.statusText;
     this.bolXmlCreationTxtMessage = true;
     this.isViewXmlButton = true;      
  }
}

isFalseValueEvent()
{
  this.bolXmlCreationMessage = false;
}

parseXML(data) {
  return new Promise(resolve => {
  // tslint:disable-next-line:one-variable-per-declaration
  let k: string | number,
  // tslint:disable-next-line:prefer-const
  arr = [],
      // tslint:disable-next-line:prefer-const
      parser = new xml2js.Parser(
        {
          trim: true,
          explicitArray: true
        });
  parser.parseString(data, function(err, result) {
      const obj = result.Axalta;
      // tslint:disable-next-line:forin
      // for (k in obj.Response) {
      const item = obj.Response[0];
      const responseResult = item.Status[0].$.code;
      const responseResultDesc = item.Status[0]._;

      console.log('item.Status[0].code..' + item.Status[0].$.code);
      console.log('responseResult' + responseResult);
      console.log('responseResultDesc' + responseResultDesc);

      arr.push({
          // id: item.AxaltaCartKey[0],
          // name: item.SupplierDocReferenceNumber[0],
          responseResult: item.Status[0],

        });
      // }
      resolve(arr);
      // this.responseResult = responseResult;
      // this.responseResultDesc = responseResultDesc;
      // if (responseResult === '200'){
      //   this.bolSuccessMessage = 'BOL XML is successfully generated';

      // } else {
      //   this.bolSuccessMessage = responseResultDesc;
      // }

      console.log('this.responseResult' + this.responseResult);
      console.log('this.responseResultDesc' + this.responseResultDesc);
      // console.log('op..' + arr[0]);
    });
  });
}


resetAllFields() {  
  this.isRestButtonClicked = true;
  this.resetModalPopup = false;
  this.getBolData();  
  this.supplierDocError = '';  
  this.supplierDocReferenceNumberModal = '';
  this.freight = '';  
  this.isViewXmlButton = true;
  this.resetBtnEnableDisable =  true;
  
  this.isCreateButton = true;    
}

exportBolName(){
  const year = this.datePipe.transform(this.customerOrderDate, 'y');
  const month = this.datePipe.transform(this.customerOrderDate, 'MM');
  const date = this.datePipe.transform(this.customerOrderDate, 'd');
  const hour = this.datePipe.transform(this.customerOrderDate, 'HH');
  const min = this.datePipe.transform(this.customerOrderDate, 'mm');
  const sec = this.datePipe.transform(new Date(), 'ss');

  this.bolFileName = year + '_' + month +  '_' + date +  '_' + hour +  '_' + min +  '_' + sec +  '_' + this.poNumber + '_BoL';


}


ViewBOL() {    
  this.isFromViewBol = true;
  this.loading = true;
  //this.bolValidation();
  
  if (this.partnerModal !== '-1' && this.poTypeModal !== '-1' &&
  this.copySupplierDocReferenceNumberModal !== undefined && this.copySupplierDocReferenceNumberModal !== '' ) {
  this.billOfLadingHeader = {
    customerOrderDate: '' + this.datePipe.transform(this.customerOrderDate, 'y-MM-ddTHH:mm:ss'),
    customerOrderID: '' + this.poNumber,
    axaltaCartKey: '' + this.axaltaCartKey,
    supplierShipDate: '' +   this.datePipe.transform(this.distributorBolDate, 'y-MM-ddTHH:mm:ss') ,
    supplierDocReferenceNumber: '' + this.copySupplierDocReferenceNumberModal,
    
  };
  
  this.itemList = [];
  this.bolItemLinesResponseDtoList.forEach(pdto => {
    console.log('pdto.bolQuantity..' + pdto.bolQuantity);
        
    let item: ItemList;
    item = {
      customerLineNumber: '' + pdto.line,
      supplierPartID: '' + pdto.supplierPartID,
      axaltaPartID: '' + pdto.axaltaPartID,
      //supplierShippedQuantity: '' + pdto.shippedQuantity,
      supplierShippedQuantity: '' + this.bolItemLinesResponseDtoListCopy[pdto.line-1],
      supplierUnitOfMeasure: '' + pdto.supplierUom,
      customerPartID: '' ,
      chkBolLineItem: this.bolItemLinesResponseDtoChkBoxListCopy[pdto.line-1],
    };
    this.itemList.push(item);
  });
  
  this.bolGenXML = {
    partnerId: this.partnerModal,
    poType: this.poTypeModal,
    billOfLading: {
      billOfLadingHeader: this.billOfLadingHeader,
      itemList: this.itemList
    }

  };
  console.log('request json....' + this.bolGenXML);
  this.bolSuccessMessage = '';
  
  if (this.poTypeModal === 'Standard PO' ) {  
    this.httpclientService.viewBOL(this.bolGenXML).subscribe(
      data => {
        this.bolResponse = data;
        this.exportBolName();
        // alert("response.."+ this.bolResponse.bolResponse);
        console.log('response json....' + this.bolResponse.bolResponse);
        this.xmlFileService.ExportXmlFile(this.bolResponse.bolResponse, this.bolFileName);
        this.loading = false;
        this.isViewXmlButton = false;
      }
    );
  } else {  
    this.httpclientService.viewBOL(this.bolGenXML).subscribe(
      data => {
        this.bolResponse = data;
        // alert("response.."+ this.bolResponse.bolResponse);
        this.exportBolName();
        console.log('response json....' + this.bolResponse.bolResponse);
        const blob = new Blob([this.bolResponse.bolResponse], { type: 'application/xml' });
        this.xmlFileService.ExportXmlFile(this.bolResponse.bolResponse, this.bolFileName);
        this.loading = false;
        this.isViewXmlButton = false;
      }
    );
  }
} else {  
  this.loading = false;
  //this.bolValidation();
}
}

clearField(){
  this.supplierDocReferenceNumberModal=""
}

keyPressNumbersDecimal(event) {
  var inp = String.fromCharCode(event.keyCode);
    // Allow numbers, alpahbets, comma, underscore,hyphan
    if (/[a-zA-Z0-9-_,]/.test(inp)) {
      //console.log("---------------------------------------" + true);
      this.supplierDocError="";
      this.onSearchChange(inp);
      
    } else {
      event.preventDefault();
      this.supplierDocError="Special characters and space are not allowed.";
      //console.log("---------------------------------------" + false);
    }
 
}

onSearchChange(searchValue: string): void {  
  console.log(searchValue);
  let isDisableBtn = true;
  let lineItemQtySum = 0;
  var len = searchValue.length  
  this.isCreateButtonVisible = true; 

  if(len > 0)
  {

    this.supplierDocErrorContain = '';
    this.supplierDocError=""       
    this.resetBtnEnableDisable =  false;

  }
  else
  { 
    this.isCreateButton =true;  
    this.resetBtnEnableDisable =  true;  
    this.supplierDocErrorContain = len;    
    this.supplierDocError='Please enter the Supplier Doc Ref No.';  
    isDisableBtn = false;
  }   
  
  if(isDisableBtn)
  {
   this.bolItemLinesResponseDtoList.forEach(pdto => {  
   lineItemQtySum += lineItemQtySum + pdto.bolQuantity ;
    });
   }
  
   if(lineItemQtySum > 0)
   {
    this.isCreateButton =false;
   }
}

onSelect(selectedChkIndex: any, values: any) {
  
  if(values.currentTarget.checked)
  {  
    this.bolItemLinesResponseDtoList[selectedChkIndex].cancleLineItemCheckBox = true;  
  }
  else
  {   
    this.bolItemLinesResponseDtoList[selectedChkIndex].cancleLineItemCheckBox = false;  
  }
}
}
